/**
 * @typedef {Object} RowGroupPluginOptions
 * @property {Boolean} [allowCollapsing]
 */

/**
 * @param {RowGroupPluginOptions} [options = {}]
 *
 * @returns {import("../datagrid").Plugin}
 */
export function rowGroupPlugin(options = {}) {
  return {
    options: {
      // Options are not deep-merged, so if another plugin was to use the `toolbar` option,
      // it would override and we would probably lose the  `groupPanel` option.
      //
      // This should not be an issue because we do not use any of the other toolbar items
      // (https://js.devexpress.com/jQuery/Documentation/ApiReference/UI_Components/dxDataGrid/Configuration/toolbar/items/)
      // and if we did, we would probably want to override them with our own UI.
      //
      // However, if the problem ever occurs, there is probably a way to circumvent this
      // by adding the toolbar items in each plugin using the `onToolbarPreparing` callback.
      // In this case, one has to consider that the toolbar is not visible by default.
      toolbar: { visible: true, items: ["groupPanel"] },
      grouping: {
        allowCollapsing: options.allowCollapsing ?? true,
      },
      groupPanel: {
        visible: true,
        allowColumnDragging: true,
      },
    },
  };
}
